import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import {
  selectAddressCurrentContractActive,
  selectAddressesConfigData,
  selectCurrentAddressData,
} from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormSelectors'
import { selectAuthData } from '../../../Login/AuthSelectors'
import useRetrieveActiveContractIdAndType from '../../Layouts/useRetrieveActiveContractIdAndType'
import { modulesConfig } from '@/containers/SubscriptionFormPageNew/config'

const useDistributor = () => {
  const { t } = useTranslation()
  const { activeTab } = useRetrieveActiveContractIdAndType()
  const {
    cityEligibility,
    label = '',
    zipcode = '',
  } = useSelector(activeTab === 'client' ? selectCurrentAddressData : selectAddressCurrentContractActive)
  const addressesConfig = useSelector(selectAddressesConfigData)

  const eldElectricity = cityEligibility?.elec_eld_details ?? {}
  const eldGas = cityEligibility?.gas_eld_details ?? {}
  const eldWater = cityEligibility?.water_details ?? {}
  const { country } = useSelector(selectAuthData)

  const buildAddress = (label, zipcode) => {
    const safeLabel = label?.trim()
    const safeZip = zipcode?.trim()
    if (safeLabel && safeZip) return `${safeLabel} (${safeZip})`
    if (safeLabel) return safeLabel
    if (safeZip) return safeZip
    return ''
  }

  const address = buildAddress(label, zipcode)

  const noDistributorData =
    Object.keys(eldElectricity).length === 0 && Object.keys(eldGas).length === 0 && Object.keys(eldWater).length === 0

  const isCityEligibilityLoading = addressesConfig?.addressCityEligibilityIsLoading ?? false

  return {
    t,
    eldElectricity,
    eldGas,
    eldWater,
    address,
    noDistributorData,
    isCityEligibilityLoading,
    country,
    hidden: !modulesConfig[country]?.rightPanel?.distributor,
  }
}

export default useDistributor
